import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router";

import {
  StyledLoginAsSuperAdmin,
  Styledloginbg,
  StyledLoginButtonLogin,
  StyledLoginForgotPassword,
  StyledLoginMainContent,
  StyledLoginMainHeading,
  StyledLoginName,
  StyledLoginNameInput,
  StyledLoginPassword,
  StyledLoginPasswordInput,
} from "./style.login";
import { loginAdmin } from "../../api/auth/auth";

const Login = () => {
  const [isSuperAdmin, setIsSuperAdmin] = useState(false);
  const [userName, setUserName] = useState("nihalavulan");
  const [userPassword, setUserPassword] = useState("1234");
  const [errorMsg, seterrorMsg] = useState(null);

  let navigate = useNavigate()

  useEffect(() => {
    setUserName('')
    setUserPassword('')

  }, [isSuperAdmin])


  useEffect(() => {
    seterrorMsg('')
  }, [userName, userPassword])

  const showDetails = async () => {

    if (userName.trim() === "") {
      seterrorMsg('Username is required')
      return
    }

    if (userPassword.trim() === '') {
      seterrorMsg('Password is required')
      return
    }

    const adminData = {
      name: userName,
      password: userPassword,
      isSuperAdmin
    }

    const data = await loginAdmin(adminData)
    console.log(data, "data")
    if (data.status === false) {
      seterrorMsg(data.msg)
    } else {
      seterrorMsg('')
      navigate("/")
    }



  };

  return (
    <>
      <Styledloginbg>
        <StyledLoginMainContent>
          <StyledLoginMainHeading>
            {isSuperAdmin ? "Super Admin Login " : "Admin Login"}
          </StyledLoginMainHeading>
          <StyledLoginName>Username</StyledLoginName>

          <StyledLoginNameInput
            value={userName}
            onChange={(e) => setUserName(e.target.value)}
            type="text"
          />
          <StyledLoginPassword>Password</StyledLoginPassword>
          <StyledLoginPasswordInput
            value={userPassword}
            onChange={(e) => setUserPassword(e.target.value)}
            type="password"
          />
          <StyledLoginForgotPassword >
            forgot password?
          </StyledLoginForgotPassword>

          {errorMsg && <p style={{ color: "red", marginLeft: "120px", marginTop: "17px" }}>{errorMsg}</p>}
          <StyledLoginButtonLogin onClick={showDetails}>
            Login
          </StyledLoginButtonLogin>

          <StyledLoginAsSuperAdmin
            onClick={() => setIsSuperAdmin(!isSuperAdmin)}
          >
            {isSuperAdmin ? "login as admin" : "login as super admin"}
          </StyledLoginAsSuperAdmin>
        </StyledLoginMainContent>
      </Styledloginbg>
    </>
  );
};

export default Login;
